import { Injectable, OnDestroy } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { BehaviorSubject, Observable, filter } from 'rxjs'
import { EVENT_NAMES } from '../../utils/events'

@Injectable({
  providedIn: 'root',
})
export class LoaderService implements OnDestroy {
  private active$ = new BehaviorSubject<boolean>(true)

  private routerSubscription: any

  public getLoader(): Observable<boolean> {
    return this.active$
  }

  public updateLoader = (active: boolean) => {
    this.active$.next(active)
  }

  public handleLoader = (event: Event) => {
    const { detail } = event as CustomEvent<{ active: boolean }>
    if (!detail) return
    this.active$.next(detail.active)
  }

  constructor(private router: Router) {
    window.addEventListener(EVENT_NAMES.loader, this.handleLoader)

    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(_event => {
        this.updateLoader(true)
      })
  }

  ngOnDestroy(): void {
    window.removeEventListener(EVENT_NAMES.loader, this.handleLoader)
    this.routerSubscription.unsubscribe()
  }
}
